import { injectable } from "inversify";
import { HttpSystemCode, ISystemCodeParser } from "../systemRepository.types";
import { Result, err, ok } from "neverthrow";
import { ISystemCode, SystemCode } from "@/domain/entities/system";
import { ParseError } from "@/repositories/shared/errors/parseError";

@injectable()
export class SystemCodeParser implements ISystemCodeParser {
  constructor() {}

  toDomain(data: HttpSystemCode): Result<ISystemCode, ParseError> {
    try {
      const systemCodeData: ISystemCode = {
        code: data.code,
        codeGroup: data.codeGroup,
        parentCode: data.parentCode,
        name: data.name,
        isUsable: data.useYn,
        displayOrder: data.displayOrder,
        priorityOrder: data.priorityOrder,
      };
      const systemCode = new SystemCode(systemCodeData);
      return ok(systemCode);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
